
import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { motion } from 'framer-motion';
import cleaningImage from '../assets/cleaning.png';
import taxesImage from '../assets/taxes.png';
import ConciergeImage from '../assets/ConciergeService.jpg';
import homeInspectionImage from '../assets/Home inspection.png';

const Services = () => {
  const services = [
    { 
      title: 'Home Inspection', 
      description: 'Thorough home inspections to ensure your peace of mind.',
      img: homeInspectionImage
    },
    { 
      title: 'Tax Services & Insurance', 
      description: 'Expert tax preparation and planning for individuals and businesses.',
      img: taxesImage
    },
    { 
      title: 'Concierge Services', 
      description: 'Our concierge service provides personalized assistance to make your life easier. From scheduling appointments to coordinating travel and handling daily tasks, we take care of the details so you can focus on what matters most.',
      img: ConciergeImage
    },
    { 
      title: 'Cleaning Services', 
      description: 'Professional cleaning services for homes and offices. Pressure washing driveway services.',
      img: cleaningImage 
    },
  ];

  return (
    <section id="services" className="services-section py-5">
      <Container>
        <h2 className="text-center mb-5">Our Services</h2>
        <Row>
          {services.map((service, index) => (
            <Col md={6} lg={3} className="mb-4" key={index}>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.5 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Card className="h-100 shadow-sm">
                  {service.img && <Card.Img variant="top" src={service.img} />}
                  <Card.Body className="text-center">
                    <Card.Title>{service.title}</Card.Title>
                    <Card.Text>{service.description}</Card.Text>
                  </Card.Body>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default Services;
